module.exports = __webpack_public_path__ + "img/im.53005849.png";